<template>
  <div class="actions_btns">
    <slot />
  </div>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `actions_btns`（`PartsActionBtn` を並べる枠）。27箇所。
 *
 * 支給では中身が1個（次へだけ／戻るだけ）と2個（戻る＋次へ）の両方がある。
 * 並べ方は支給CSSが持つのでここでは持たない。
 */
</script>
